if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.termsPopup = document.querySelector('.js-terms-popup');
      this.termsPopupOpenBtn = document.querySelector('.js-terms-popup-open');
      this.openPopupHandler = this.openPopup.bind(this);
      this.termsPopupOpenBtn.addEventListener('click', this.openPopupHandler);

      if (theme.cartValidation.brandValidationIsSuccess()) {
        this.submitHandler = this.handleSubmit.bind(this);
        this.form.addEventListener('submit', this.submitHandler);
      }
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */

    openPopup(evt) {
      if (this.termsPopup) {
        this.termsPopup.setAttribute('open', '');
        let submitBtn = this.termsPopup.querySelector('.js-submit-terms');
        if (submitBtn) {
          submitBtn.addEventListener('click', (e) => {
            this.cartTermsCheckbox.checked = true;
            this.termsPopup.removeAttribute('open');
          })
        }
      }
    }

    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        
      }
    }
  }
  customElements.define('cart-terms', CartTerms);
}
